import ReactQuill from "react-quill"
import styled from "styled-components"

export const ReactQuillStyled = styled(ReactQuill)`
  margin-top: 20px;

  .ql-editor {
    padding: 0;
  }

  .ql-editor {
    font-size: 16px;
  }
`
